import { SliceState, Status } from "../../types/common";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CouponApi } from "../../api/CouponApi";
import { RootState } from "../index";
import { CouponHistoryListDTO, CouponListSearchCondition } from "../../types/coupon";
import { executePromise } from "../../util/sliceUtil";

export interface CouponState extends SliceState {
  coupons?: CouponHistoryListDTO[];
  userCouponCount: number;
}

const initialState: CouponState = {
  status: Status.IDLE,
  userCouponCount: 0,
};

export const getUserCouponCountAsync = createAsyncThunk("coupon/getUserCouponCount", () =>
  executePromise(CouponApi.getCouponCount())
);

export const getMyCouponListAsync = createAsyncThunk("coupon/getMyCouponList", (condition: CouponListSearchCondition) =>
  executePromise(CouponApi.getMyCouponList(condition))
);

export const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    setCoupons: (state, action: PayloadAction<CouponHistoryListDTO[]>) => {
      state.coupons = action.payload;
    },
    setUserCouponCount: (state, action: PayloadAction<number>) => {
      state.userCouponCount = action.payload;
    },
  },
});

export const { setCoupons, setUserCouponCount } = couponSlice.actions;

export const couponStatus = (state: RootState) => state.coupon.status;
export const couponList = (state: RootState) => state.coupon.coupons;
export const userCouponCountState = (state: RootState) => state.coupon.userCouponCount;

export default couponSlice.reducer;
